var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"回放记录","visible":_vm.showTag,"append-to-body":true,"width":"80%"},on:{"update:visible":function($event){_vm.showTag=$event}}},[_c('div',{staticStyle:{"height":"500px"},attrs:{"id":"player-con"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }